<div class="dialoghead">
  <h1 class="mat-mdc-dialog-title">Confirmation!!</h1>
  <mat-dialog-content>
    <p>
      Looks like a few optional (but important) details are still needed. No problem, You can add these after signing up. Proceed for now?
    </p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="onConfirm()">Proceed</button>
    <button mat-button (click)="onCancel()">Cancel</button>
  </mat-dialog-actions>
</div>

<span (click)="onCancel()" class="close-btn-modal material-icons"
  >close</span
>